const MyIcon = ({ name, style }) => {
  return (
    <svg className="general-icon" aria-hidden="true" style={style}>
      <use xlinkHref={`#icon-${name}`}></use>
    </svg>
  );
};

export default MyIcon;
